/* eslint-disable no-console */
import { FullStory, init as initializeFullStory } from '@fullstory/browser';
import { ENDPOINTS, ERRORS } from '../enums';

// FULLSTORY ADAPTER
export class MonitoringAdapter {
	static init() {
		initializeFullStory({ orgId: process.env.FULLSTORY_ID });
	}

	static identify(userData) {
		FullStory('setIdentity', {
			uid: userData.email,
			properties: {
				...userData,
			},
		});
	}

	static trackEvent(eventName, eventData) {
		FullStory('trackEvent', {
			name: eventName,
			properties: {
				...eventData,
			},
		});
	}
}

// SENTRY
export const mockSentry = () => {
	window.Sentry = {
		mocked: true,
		captureException: function (message, type) {
			console.log('Sentry mocked exception', message, type);
		},
		captureMessage: function (message, type) {
			console.log('Sentry mocked exception', message, type);
		},
		withScope: function (scope) {
			console.log('Sentry mocked withScope', scope);
		},
		getCurrentHub: function () {
			return {
				bindClient: function () {
					console.log('Sentry mocked bindClient');
				},
			};
		},
		// Mock Sentry constructors to avoid microapps crashing
		BrowserClient: function () {
			console.log('Sentry mocked BrowserClient');
		},
		Integrations: {
			Vue: function () {
				console.log('Sentry mocked Vue Integration');

				return {
					name: 'Vue',
					setupOnce: () => {},
				};
			},
		},
	};
};

// INTERCOM
export const initIntercom = (userDataIntercom, customerData, keycloak) => {
	// We fetch the user_hash that we must provide to intercom for security verification
	// If it fails then intercom should not launch
	API.GET(ENDPOINTS.INTERCOM_HASH, {
		headers: {
			Authorization: `Bearer ${keycloak.token}`,
			'customer-id': customerData.id,
		},
	})
		.then((res) => {
			const user_hash = res?.data?.hash;
			if (user_hash != null) {
				userDataIntercom.user_hash = res.data.hash;

				setTimeout(() => {
					window.Intercom('boot', userDataIntercom);
				}, 1000);
			} else {
				throw new Error(ERRORS.INVALID_HASH);
			}
		})
		.catch((error) => {
			Sentry.captureException(error);
		});
};

export const mockIntercom = () => {
	window.Intercom = (func, params) => {
		console.log(`Intercom mock called function ${func} with params ${params}`);
	};
};
